import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../../context/authContext";
const AuthRoutes = ({ children }) => {
  const { user } = useContext(AuthContext);
  const currentUser = user.role || user.roles[0];

  return currentUser ? children : <Navigate to="/" />;

  // return children
};

export default AuthRoutes;
